import React, { Suspense } from "react";
import { BrowserRouter, Routes, Route, Navigate } from "react-router-dom";
import { AuthProvider } from "@d-m-organization/hub-shared-lib/auth";
import { PricingProvider } from "@d-m-organization/pricing-ui";
import { Dashboard, QrDashboard, PlannerDashboard } from "./routes/Dashboard.js";
import { LoginRoute } from "./routes/LoginRoute.js";
import { SignupRoute } from "./routes/SignupRoute.js";
import { AuthCallback } from "./routes/AuthCallback.js";
import { SilentCallback } from "./routes/SilentCallback.js";
import { PricingPage } from "./routes/PricingPage.js";
import { TermsPage } from "./routes/legal/TermsPage.js";
import { PrivacyPage } from "./routes/legal/PrivacyPage.js";
import { SettingsPlaceholder } from "./routes/SettingsPlaceholder.js";
import { PageLoadingShell } from "./components/PageLoadingShell.js";
import { AuthGate } from "./auth/AuthGate.js";

const QrQuickCreatePage = React.lazy(() => import("./routes/QrQuickCreate.js"));
const LinkConfirmRoute = React.lazy(() => import("./routes/LinkConfirmRoute.js"));
const InviteAcceptRoute = React.lazy(() => import("./routes/InviteAcceptRoute.js"));
const SecurityRoute = React.lazy(() => import("./routes/SecurityRoute.js"));
const BillingRoute = React.lazy(() => import("./routes/BillingRoute.js"));

export function App() {
  return (
    <AuthProvider>
      <PricingProvider apiBase={import.meta.env.VITE_API_BASE_URL}>
        <BrowserRouter>
          <AuthGate>
            <Routes>
              <Route path="/" element={<Dashboard />} />
              <Route path="/qr" element={<QrDashboard />} />
              <Route path="/planner" element={<PlannerDashboard />} />
              <Route path="/pricing" element={<PricingPage />} />
              <Route path="/terms" element={<TermsPage />} />
              <Route path="/privacy" element={<PrivacyPage />} />
              <Route path="/settings" element={<SettingsPlaceholder />} />
              <Route path="/login" element={<LoginRoute />} />
              <Route path="/signup" element={<SignupRoute />} />
              <Route path="/auth/callback" element={<AuthCallback />} />
              <Route path="/auth/silent-callback" element={<SilentCallback />} />
              <Route path="/auth/link-confirm" element={<Suspense fallback={<PageLoadingShell />}><LinkConfirmRoute /></Suspense>} />
              <Route path="/invites/:invitationId" element={<Suspense fallback={<PageLoadingShell />}><InviteAcceptRoute /></Suspense>} />
              <Route path="/account/security" element={<Suspense fallback={<PageLoadingShell />}><SecurityRoute /></Suspense>} />
              <Route path="/account/billing" element={<Suspense fallback={<PageLoadingShell />}><BillingRoute /></Suspense>} />
              <Route path="/qr/new" element={<Suspense fallback={<PageLoadingShell />}><QrQuickCreatePage /></Suspense>} />
              <Route path="*" element={<Navigate to="/" replace />} />
            </Routes>
          </AuthGate>
        </BrowserRouter>
      </PricingProvider>
    </AuthProvider>
  );
}
